import axios from 'axios'
import { RedFunnelAPI } from './redFunnelAPI'

export const redFunnelAPI = new RedFunnelAPI(axios, {
  clientId: process.env.REACT_APP_CLIENT_ID,
  dolliEndpoint: process.env.REACT_APP_DOLLI_ENDPOINT,
  crypto: window.crypto,
})
